const DROPDOWN_CLOSE_DELAY = 120;
const OPEN_CLASS = "open";
const SCROLLED_CLASS = "scrolled";
const MOBILE_MENU_OPEN_CLASS = "is-open";
const MOBILE_BODY_OPEN_CLASS = "mob-menu-open";
const MOBILE_SECTION_OPEN_CLASS = "mob-open";
const RW_EXPENDED = "rw-expanded";

let lastScrollY = 0;

const rwExpand = document.getElementById("rw-expand");
const navbar = document.getElementById("navbar");
const navItems = document.querySelectorAll<HTMLElement>(
  ".nav-item[data-has-dropdown]"
);
const langItem = document.querySelector<HTMLElement>(".lang-item");
const langBtn = langItem?.querySelector<HTMLElement>(".lang-btn") ?? null;
const burgerBtn = document.getElementById("burger-btn");
const mobileMenu = document.getElementById("mobile-menu");
const mobCloseBtn = document.getElementById("mob-close-btn");
const mobAccordionItems = document.querySelectorAll<HTMLElement>(
  ".mob-nav-item[data-mob-accordion]"
);
const mobLangSection = document.getElementById("mob-lang-section");
const mobLangTrigger = document.getElementById("mob-lang-trigger");

function setExpanded(element: Element | null, expanded: boolean): void {
  if (element) {
    element.setAttribute("aria-expanded", String(expanded));
  }
}

function getNavButton(item: Element): HTMLElement | null {
  return item.querySelector<HTMLElement>(".nav-link-btn");
}

function setNavItemOpen(
  item: Element,
  button: Element | null,
  isOpen: boolean
): void {
  item.classList.toggle(OPEN_CLASS, isOpen);
  setExpanded(button, isOpen);
}

function closeNavItem(item: Element): void {
  setNavItemOpen(item, getNavButton(item), false);
}

function closeNavItems(exceptItem?: Element): void {
  navItems.forEach(item => {
    if (item !== exceptItem) {
      closeNavItem(item);
    }
  });
}

function closeLanguageDropdown(): void {
  if (langItem) {
    langItem.classList.remove(OPEN_CLASS);
  }

  setExpanded(langBtn, false);
}

function isOutside(target: EventTarget | null, selector: string): boolean {
  return !(target instanceof Element) || !target.closest(selector);
}

function updateScrollState(): void {
  const currentScrollY = window.scrollY;

  if (navbar) {
    navbar.classList.toggle(SCROLLED_CLASS, currentScrollY > 0);
  }

  if (currentScrollY > lastScrollY + 100) {
    document.body.classList.remove(RW_EXPENDED);
  }
}

function openMobileMenu(): void {
  if (!mobileMenu) {
    return;
  }

  mobileMenu.classList.add(MOBILE_MENU_OPEN_CLASS);
  document.body.classList.add(MOBILE_BODY_OPEN_CLASS);
  setExpanded(burgerBtn, true);
}

function closeMobileMenu(): void {
  if (!mobileMenu) {
    return;
  }

  mobileMenu.classList.remove(MOBILE_MENU_OPEN_CLASS);
  document.body.classList.remove(MOBILE_BODY_OPEN_CLASS);
  setExpanded(burgerBtn, false);
}

function closeMobileAccordionItems(): void {
  mobAccordionItems.forEach(item => {
    item.classList.remove(MOBILE_SECTION_OPEN_CLASS);
    setExpanded(item.querySelector<HTMLElement>(".mob-nav-btn"), false);
  });
}

window.addEventListener("scroll", updateScrollState, { passive: true });
updateScrollState();

navItems.forEach(item => {
  const button = getNavButton(item);
  let closeTimer: any;

  item.addEventListener("mouseenter", () => {
    if (closeTimer !== undefined) {
      window.clearTimeout(closeTimer);
    }

    closeNavItems(item);
    setNavItemOpen(item, button, true);
  });

  item.addEventListener("mouseleave", () => {
    closeTimer = window.setTimeout(() => {
      setNavItemOpen(item, button, false);
    }, DROPDOWN_CLOSE_DELAY);
  });
});

if (langItem) {
  let langTimer: any;

  langItem.addEventListener("mouseenter", () => {
    if (langTimer !== undefined) {
      window.clearTimeout(langTimer);
    }

    langItem.classList.add(OPEN_CLASS);
    setExpanded(langBtn, true);
  });

  langItem.addEventListener("mouseleave", () => {
    langTimer = window.setTimeout(() => {
      closeLanguageDropdown();
    }, DROPDOWN_CLOSE_DELAY);
  });
}

document.addEventListener("click", event => {
  if (isOutside(event.target, ".nav-item[data-has-dropdown]")) {
    closeNavItems();
  }

  if (langItem && isOutside(event.target, ".lang-item")) {
    closeLanguageDropdown();
  }
});

if (burgerBtn) {
  burgerBtn.addEventListener("click", openMobileMenu);
}

if (mobCloseBtn) {
  mobCloseBtn.addEventListener("click", closeMobileMenu);
}

mobAccordionItems.forEach(item => {
  const button = item.querySelector<HTMLElement>(".mob-nav-btn");

  if (!button) {
    return;
  }

  button.addEventListener("click", () => {
    const isOpen = item.classList.contains(MOBILE_SECTION_OPEN_CLASS);

    closeMobileAccordionItems();

    if (!isOpen) {
      item.classList.add(MOBILE_SECTION_OPEN_CLASS);
      setExpanded(button, true);
    }
  });
});

if (mobLangTrigger && mobLangSection) {
  mobLangTrigger.addEventListener("click", () => {
    const isOpen = mobLangSection.classList.toggle(MOBILE_SECTION_OPEN_CLASS);
    setExpanded(mobLangTrigger, isOpen);
  });
}

if (rwExpand) {
  rwExpand.addEventListener("click", () => {
    document.body.classList.toggle(RW_EXPENDED);
    lastScrollY = window.scrollY;
  });
}
